<script lang="ts">
  export let code: string;
  export let alt: string = "";
</script>

{#if code === "nil"}
  <div class="verbaflo-widget-flag-placeholder">
    <span class="verbaflo-widget-flag-placeholder-text">?</span>
  </div>
{:else}
  <img
    src="https://flagpedia.net/data/flags/h80/{code.toLowerCase()}.png"
    alt={alt || `${code} flag`}
    class="verbaflo-widget-flag-image"
  />
{/if}

<style>
  :global(#vfwidget .verbaflo-widget-flag-icon) {
    width: 24px !important;
    height: 16px !important;
  }

  :global(#vfwidget .verbaflo-widget-flag-placeholder) {
    background-color: #d1d5db !important;
    border-radius: 2px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 24px !important;
    height: 16px !important;
  }

  :global(#vfwidget .dark .verbaflo-widget-flag-placeholder) {
    background-color: #4b5563 !important;
  }

  :global(#vfwidget .verbaflo-widget-flag-placeholder-text) {
    font-size: 12px !important;
    color: #6b7280 !important;
  }

  :global(#vfwidget .dark .verbaflo-widget-flag-placeholder-text) {
    color: #9ca3af !important;
  }

  :global(#vfwidget .verbaflo-widget-flag-image) {
    border-radius: 2px !important;
    object-fit: cover !important;
    border: 1px solid #e5e7eb !important;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
    width: 24px !important;
    height: 16px !important;
  }

  :global(#vfwidget .dark .verbaflo-widget-flag-image) {
    border-color: #4b5563 !important;
  }
</style>
